import type { PricingStatus } from '../types/application';

// Borrower-facing language for each pricing state. Selection is never a lock.
export const pricingStatuses: Record<PricingStatus, { label: string; detail: string; tone: 'neutral' | 'pending' | 'positive' }> = {
  presented: {
    label: 'Options ready',
    detail: '{{loanOfficerFirstName}} has shared loan options for you to review.',
    tone: 'neutral',
  },
  selected: {
    label: 'Selected · not locked',
    detail: 'You’ve selected this option. {{loanOfficerFirstName}} will confirm final pricing before your rate is locked.',
    tone: 'pending',
  },
  confirmed: {
    label: 'Confirmed by {{loanOfficerFirstName}}',
    detail: 'Your pricing is confirmed. Your rate isn’t locked yet — {{loanOfficerFirstName}} will reach out about timing.',
    tone: 'pending',
  },
  floating: {
    label: 'Floating',
    detail: 'Your rate isn’t locked and can move with the market. {{loanOfficerFirstName}} is watching it for you.',
    tone: 'pending',
  },
  locked: {
    label: 'Rate locked',
    detail: 'Your rate is locked and won’t change before closing as long as nothing in your application changes.',
    tone: 'positive',
  },
};
